<template>
  <div class="container-fluid">
    <div class="row p-2">
      <div class="col-12 mb-3">
        <user-info-header></user-info-header>
      </div>
      <div class="col-md-2 col-12">
        <span>درخواست پرداخت مبلغ</span>
      </div>
      <div class="col-md-2 col-12">
        <input v-model="data.amount" @keyup="data.amount = $PutCommatoInput_New($event)" @keypress="$ValidNumber($event, 15)" type="text" class="form-control text-left" dir="ltr" />
      </div>
      <div class="col-md-3 col-12">
        ریال به اقای/خانم

        <span class="font-weight-bold"> {{ ' ' + $session.get('UserInfo').namFam }}</span>
      </div>
      <div class="col-md-1 col-1">بابت</div>
      <div class="col-md-4 col-12">
        <SearchableCombo :edit="false" :grp="104" :code="null" @ResultCombo="GetResulttblComboGrp104" :rownumintable="3" :defaultvalue="data.tblComboGrp104" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'tblComboGrp104'" :keyItem="'tblComboGrp104'" :disabled="false">
        </SearchableCombo>
      </div>
      <div class="col-md-8 col-12">
        <small>توضیحات</small>
        <textarea v-model="data.description" type="text" class="form-control" rows="5"></textarea>
      </div>
     
      <div class="col-md-4 col-12">
        <uploader @upload="GetFile"></uploader>
      </div>
    </div>
    <div class="row p-2">
      <div class="col-md-8 col-12"></div>
      <div class="col-md-4 col-12">
        <div class="row">
          <div class="col-md-6 col-12">
            <!-- <button @click="cancel" class="btn btn-outline-danger w-100">لغو</button> -->
          </div>
          <div class="col-md-6 col-12">
            <button v-if="!Isedit" @click="submit(true)" class="btn btn-success w-100">ثبت</button>
            <button v-if="Isedit" @click="submit(false)" class="btn btn-warning w-100">ثبت</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserInfoHeader from '@/components/AutomAtion/UserInfoHeader.vue'
import Uploader from '@/components/Uploader/Uploader.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
  props: ['Isedit', 'EditData'],
  components: { UserInfoHeader, Uploader, SearchableCombo },
  data() {
    return {
      File: null,
      data: {
        id: 11,
        amount: 0,
        tblComboGrp104: null,
        tblUserId: this.$session.get('userId'),
        filepath: null,
        dateTimeInsert: null,
        tblUserGrpIdInsert: null,
        description: null,
        dateTimeLastEdit: null,
        tblUserGrpIdLastEdit: null,
      },
    }
  },
  methods: {
    GetFile(file) {
      this.File = file
    },
    GetResulttblComboGrp104(combo) {
      this.data.tblComboGrp104 = combo.id
    },
    submit(IsNew) {
      var SendData = { Action: 'PaymentPermission', Method: 'POST', ArryfildValue: null }

      if (IsNew) {
        SendData.Action = 'PaymentPermission'
      } else {
        SendData.Action = 'PaymentPermission/EditPaymentPermission'
      }
      this.data.amount = Number(this.data.amount.replace(/,/g, ''))
      console.clear()
      var formData = new FormData()
      for (var key in this.data) {
        if (this.data[key] == null || this.data[key] == '') {
          formData.append(key, null)
        } else {
          formData.append(key, this.data[key])
        }
      }
      formData.append('Amount', this.data.amount)
      formData.append('file', this.File)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        if (result.isSuccess) {
          this.$toasted.success(result.Message, { duration: 2000 })
          this.cancel()
          this.data.amount = this.data.amount + ''
        } else {
          this.$toasted.error(result.Message, { duration: 2000 })
        }
      })
    },
    cancel() {
      this.$emit('cancel', null)
    },
  },
  created() {
    if (this.Isedit) {
      this.data = this.EditData
      this.data.amount = this.$Comma3ragham(this.EditData.amount)
    }
  },
}
</script>
